/**
 * Header component with navigation and user menu.
 */
import { Link, useLocation } from 'react-router-dom'
import { UserButton } from '@clerk/clerk-react'

export const Header: React.FC = () => {
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname === path
      ? 'bg-primary-100 text-primary-700'
      : 'text-gray-700 hover:bg-gray-100'
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo and Title */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <span className="text-xl font-bold text-gray-900">
                Meeting Notes Generator
              </span>
            </Link>
          </div>

          {/* Navigation */}
          <nav className="flex items-center space-x-2">
            <Link
              to="/generate"
              className={`px-4 py-2 rounded-lg transition-colors ${isActive('/generate')}`}
            >
              Generate Report
            </Link>
            <Link
              to="/samples"
              className={`px-4 py-2 rounded-lg transition-colors ${isActive('/samples')}`}
            >
              Training Samples
            </Link>

            {/* User Button from Clerk */}
            <div className="ml-4">
              <UserButton afterSignOutUrl="/sign-in" />
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}
